import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import styled from 'styled-components'
import 'prismjs/themes/prism-coy.css'

const Article = styled.article`
  display: block;
  margin-bottom:10px;
  border: 1px solid transparent;
  &.active {
    border: 1px dashed #000;    
  }
  & > h2 {
    display: inline;
    margin-bottom: 20px;
    a {
      font-size: 30px;
      color: black;
    }
  }
`

const Detail = styled.div`
  display: block;
  margin-bottom: 30px;
`

const Comment = styled.article`
  position:relative;
  display:block;
  min-height:50px;
  margin-left: 0;
  border: 1px solid transparent;  
`

const Info = styled.span`
  position:relative;
  left:0px;
  font-size:14px;
  color:#666;
`

let P = styled.p`
  position:relative;
  left:10px;
  top:20px;
  font-family: 'Inconsolata', Courier;
  font-size: 18px;
  line-height: 1.3;
  white-space: pre-wrap;  
  word-wrap: break-word;  
  margin-bottom:10px;
`

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const { previous, next } = this.props.pathContext

    return (
      <section>
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
        <section id="newslist">
          <Article>
            <h2>
              <a href={post.fields.slug}>{post.frontmatter.title}</a>
            </h2>
          </Article>
        </section>
        <Detail>
          <Comment>
            <Info>{post.frontmatter.date}</Info>
            <P dangerouslySetInnerHTML={{ __html: post.html }} />
          </Comment>
        </Detail>
      </section>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js